var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgControlItemAdd24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.6,10.4 L13.6,1.59999996 C13.6,0.716344368 12.8836556,-3.76000003e-08 12,-3.76000003e-08 C11.1163444,-3.76000003e-08 10.4,0.716344368 10.4,1.59999996 L10.4,10.4 L1.59999996,10.4 C0.716344368,10.4 -3.76000003e-08,11.1163444 -3.76000003e-08,12 C-3.76000003e-08,12.8836556 0.716344368,13.6 1.59999996,13.6 L10.4,13.6 L10.4,22.4 C10.4,23.2836556 11.1163444,24 12,24 C12.8836556,24 13.6,23.2836556 13.6,22.4 L13.6,13.6 L22.4,13.6 C23.2836556,13.6 24,12.8836556 24,12 C24,11.1163444 23.2836556,10.4 22.4,10.4 L13.6,10.4 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconActionAdd24",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconActionAdd32"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color",
    mask: "url(#mask-2)",
    fill: "#282828",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.800000, -0.800000)",
    id: "Rectangle-Copy-11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 25.6,
    height: 25.6
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlItemAdd24);
export default __webpack_public_path__ + "static/media/controlItemAdd24.4711a1cfece6bdde330dad33a10c64fa.svg";
export { ForwardRef as ReactComponent };